
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 4h5v2H6v3H4V4zM20 4v5h-2V6h-3V4h5zM20 20h-5v-2h3v-3h2v5zM4 20v-5h2v3h3v2H4z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M4 4h5v2H6v3H4V4zM20 4v5h-2V6h-3V4h5zM20 20h-5v-2h3v-3h2v5zM4 20v-5h2v3h3v2H4z","fill":"currentColor"}})])
          )
        }
      }
    